import { Heading, HeadingProps, Text } from '@chakra-ui/react'
import { useScreen } from '@hb/react'
import { useMemo } from 'react'

export const Header = (props: HeadingProps) => (
  <Heading
    fontSize="md"
    textAlign="center"
    m={0}
    fontWeight={500}
    fontFamily="hero-new"
    {...props}
  />
)

export const PageHeader = ({ children, ...props }: HeadingProps) => {
  const { isMobile } = useScreen()
  const rendered = useMemo(() => {
    if (typeof children === 'string') {
      const words = children.split(' ')
      return words.map((w, i) => (
        <Text as="span" key={`${w}_${i}`}>
          {i === 0 ? '' : ' '}
          <Text fontSize="2rem" as="span">
            {w[0].toUpperCase()}
          </Text>
          <Text fontSize="1.8rem" as="span">
            {w.substring(1).toUpperCase()}
          </Text>
        </Text>
      ))
    }
    return children
  }, [children])
  return (
    <Header
      fontSize={isMobile ? '1.5rem' : '2rem'}
      mt={isMobile ? 6 : 12}
      padding={0}
      fontWeight={500}
      opacity={0.8}
      {...props}>
      {rendered}
    </Header>
  )
}
